export default defineNuxtPlugin({
  name: 'routes-plugin',
  enforce: 'pre', // or 'post'
  async setup(nuxtApp) {
    // this is the equivalent of a normal functional plugin
    // console.log('--- routes-plugin: setup')
  },
  // hooks: {
  //   // You can directly register Nuxt app runtime hooks here
  //   'app:created'() {
  //     const nuxtApp = useNuxtApp()
  //     // do something in the hook
  //   }
  // },
  env: {
    // Set this value to `false` if you don't want the plugin to run when rendering server-only or island components.
    islands: false,
  },
})
